package com.eladfinish.bible.contest.features.verseWidget

import kotlinx.datetime.TimeZone
import kotlin.time.Duration.Companion.days
import kotlin.time.Instant

/**
 * The verses of the next [horizonDays] days, one per slot, for a widget that cannot compute them
 * itself (the iOS one only reads a schedule the app wrote). The entry that is on screen at [from]
 * comes first and starts before [from].
 */
class BuildWidgetScheduleUseCase(
    private val getWidgetVerseUseCase: GetWidgetVerseUseCase,
) {

    operator fun invoke(
        config: VerseWidgetConfig,
        from: Instant,
        horizonDays: Int,
        timeZone: TimeZone = TimeZone.currentSystemDefault(),
    ): List<WidgetScheduleEntry> {
        val session = getWidgetVerseUseCase.session(config)
        val firstSlot = VerseWidgetSlots.slotAt(from, config, timeZone)
        val lastSlot = VerseWidgetSlots.slotAt(from + horizonDays.days, config, timeZone)
        return (firstSlot..lastSlot).mapNotNull { slot ->
            session.verseAt(slot)?.let { verse ->
                WidgetScheduleEntry(
                    startEpochSeconds = VerseWidgetSlots.startOf(slot, config, timeZone).epochSeconds,
                    verse = verse,
                )
            }
        }
    }
}
